import { render } from "./HomeHero.vue?vue&type=template&id=98ed620a"
import script from "./HomeHero.vue?vue&type=script&lang=js"
export * from "./HomeHero.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__